/*
 * @Description: 蓝牙命令
 * @Author: fengd
 * @LastEditors: fengd
 * @Date: 2019-03-25 09:39:26
 * @LastEditTime: 2019-10-22 10:43:26
 */

import RFBluetoothInstance, { replaceEnd } from '../native-interact/RFBluetooth';
import RFIDInstance, { WRITE_CPU1_PAGE, WRITE_CPU2_PAGE } from '../native-interact/RFID';
import config from './command-config';
import { event } from '../native-interact/EventEmmiter';
import { noop, runPromiseByQueue, formatDateTime } from '../js/utils';
import { getServeTime } from '.';

export const CPU2_COMMAND = ['reset cpu1', 'on bt', 'off bt'];

export const CPU1_COMMAND = [
  'reset geo',
  'reset cpu2',
  'reset radar',
  'reset rtc',
  'reboot nb',
  'reboot geo',
  'reboot lora',
  'reboot cpu2', // 这两个reboot cpu的命令比较危险，建议从cpu1执行
  'reboot cpu1',
];

const {
  version,
  upgrade,
  getParam,
  gotoRunState,
  reboot,
  init,
  rebootCpu1,
  reset,
  test,
  alterIP,
  setParam,
  quitShutdown,
  synctime
} = config;

/**
 * @description 获取命令可写入页码范围
 * @export
 * @param {string} cmd
 * @returns
 */
export function getCmdPage(cmd) {
  return CPU2_COMMAND.indexOf(cmd) >= 0 ? WRITE_CPU2_PAGE : WRITE_CPU1_PAGE;
}

// 获取当前工作状态
export function getWorkState() {
  return RFBluetoothInstance.sendCommand(
    getParam.command('app.mode'),
    getParam
  );
}

// 获取地磁信道
export function getGeoChannel() {
  return RFBluetoothInstance.sendCommand(
    getParam.command('cfg.channel'),
    getParam
  ).then((res) => {
    return res.match(/.*cfg\.channel\s*=\s*(\d+).*/)[1];
  });
}

// 设置工作模式
export function setWorkState(mode) {
  return RFBluetoothInstance.sendCommand(
    gotoRunState.command(mode),
    gotoRunState
  );
}

// 获取当前版本号
export function getVersion(target) {
  return RFBluetoothInstance.sendCommand(
    version.command(target),
    version
  ).then((data) => {
    // 解析版本号
    // console.log('读取版本号返回的内容', data);
    const versionStr = replaceEnd(data).match(new RegExp(`${target || 'cpu1'} version=.*`));
    // 解析firmwaretype
    let firmwaretype = null; // 固件类型 可能为空
    if (target === 'cpu1') {
      firmwaretype = data.split(' ')[2] ? data.split(' ')[2].split('\r')[0] : null;
    }
    if (target === 'cpu2') {
      firmwaretype = `SHERLOCKGEOBLERELEASED${versionStr[0].split('=')[1].split('.')[0]}`;
    }
    if (versionStr) {
      return {
        version: versionStr[0].split('=')[1],
        firmwaretype
      };
    }
    return null;
  });
}


/**
 * @description 升级地磁
 * @export
 * @param {string} channel 通道
 * @returns
 */
export function upgradeGeo(target, channel) {
  return RFBluetoothInstance.sendCommand(
    upgrade.command(target, channel),
    upgrade
  );
}

// 重启模组-蓝牙
export function rebootModule(target) {
  return RFBluetoothInstance.sendCommand(
    reboot.command(target),
    target === 'cpu1' ? rebootCpu1 : reboot
  );
}

// 退出低电保护模式-蓝牙
export function quitShutdownMode(target) {
  return RFBluetoothInstance.sendCommand(
    quitShutdown.command(target),
    quitShutdown
  );
}

// 校准时间-蓝牙
export function syncTime(target) {
  // 忽略本地时间获取 直接请求服务器接口获取服务器时间 同步到地磁
  return getServeTime().then(({ data }) => {
    const time = data || target;
    return RFBluetoothInstance.sendCommand(
      synctime.command(time),
      synctime
    );
  }).catch(() => {
    // 兼容网络问题 导致无法请求服务器时间
    return RFBluetoothInstance.sendCommand(
      synctime.command(target),
      synctime
    );
  });
}

// 重启设备-RFID
export function rebootModuleByRFID(target) {
  const command = `reboot ${target}`;
  const page = getCmdPage(command);
  return RFIDInstance.write(
    {
      step: 'reboot',
      desc: '重启设备'
    },
    page,
    command
  );
}

// 重置设备-RFID
export function resetModuleByRFID(target) {
  const command = `reset ${target}`;
  const page = getCmdPage(command);
  return RFIDInstance.write(
    {
      step: 'reset',
      desc: '重置设备'
    },
    page,
    command
  );
}

// 重置模组-蓝牙
export function resetModule(target) {
  return RFBluetoothInstance.sendCommand(
    reset.command(target),
    reset
  );
}

// 初始化模组-蓝牙
export function initModule(target) {
  return RFBluetoothInstance.sendCommand(
    init.command(target),
    init
  );
}

// 测试模组-蓝牙
export function testModule(target) {
  return RFBluetoothInstance.sendCommand(
    test.command(target),
    test
  );
}

export function alterIPAdress(ip) {
  return RFBluetoothInstance.sendCommand(
    alterIP.command(ip),
    alterIP
  );
}

function isRightFDISK(data) {
  return (
    data.match(/\[0:\](\s*)?452(\s*?)KiB(\s*?)total/g)
    && data.match(/\[1:\](\s*)?484(\s*?)KiB(\s*?)total/g)
    && data.match(/\[2:\](\s*)?1992(\s*?)KiB(\s*?)total/g)
  )
  || (
    // 兼容 6.72 以后的版本分区信息
    data.match(/\[0:\](\s*)?789(\s*?)KiB(\s*?)total/g)
    && data.match(/\[1:\](\s*)?787(\s*?)KiB(\s*?)total/g)
    && data.match(/\[2:\](\s*)?2409(\s*?)KiB(\s*?)total/g)
  );
}

// 获取磁盘分区
export function getFDISK() {
  return RFBluetoothInstance.sendCommand(
    'ff df',
    {
      name: '获取磁盘分区',
      expect: ''
    }
  ).then((data) => {
    if (
      isRightFDISK(data)
    ) {
      return RFBluetoothInstance.sendCommand('goto work', {
        name: '进入工作模式'
      })
        .then(() => {
          return new Error('分区正确，不需要修复');
        })
        .catch(() => {
          return new Error('分区正确，不需要修复；返回工作模式失败，请重试');
        }).then((error) => {
          return Promise.reject(error);
        });
    }
    return Promise.resolve(true);
  }).catch((error) => {
    return Promise.reject(error);
  });
}

// 获取磁盘分区for生产
export function getFDISKForProd() {
  return RFBluetoothInstance.sendCommand(
    'ff df',
    {
      name: '获取磁盘分区',
      expect: ''
    }
  ).then((data) => {
    console.log(`检查分区结果1${data}`);
    if (
      isRightFDISK(data)
    ) {
      console.log(`检查分区结果1-1${isRightFDISK(data)}`);
      return Promise.reject(new Error('分区正确，不需要修复'));
    }
    return Promise.resolve(true);
  }).catch((error) => {
    console.log(`检查分区结果2${error}`);
    return Promise.reject(error);
  });
}

// 开启日志
export function openLog(time) {
  return RFBluetoothInstance.sendCommand(
    `log bt ${time}`,
    {
      name: '开启地磁日志',
      expect: 'log bt on'
    }
  );
}

// 关闭日志
export function closeLog() {
  return RFBluetoothInstance.sendCommand(
    'log off',
    {
      name: '关闭地磁日志',
      expect: ''
    }
  );
}

export function getNbstat() {
  return RFBluetoothInstance.sendCommand(
    'nbstat',
    {
      name: '查看NB网络状态',
      expect: ''
    }
  );
}

export function getLorastat() {
  return RFBluetoothInstance.sendCommand(
    'prt app.rssi',
    {
      name: '查看Lora网络状态',
      expect: ''
    }
  );
}

// 获取地磁检测状态
export function getParkState() {
  return RFBluetoothInstance.sendCommand(
    'park',
    {
      name: '查询当前车位状态',
      expect: 'park'
    }
  ).then((data) => {
    const newData = data.replace(/\r\n/g, '');
    const result = newData.split(',');
    return Promise.resolve({
      park: result[0].split(':')[1],
      time: result[1].split(':')[1]
    });
  });
}

/**
 * @description 一键修复-等待cpu1重启: 重启cpu1命令下发后根据日志判断是否重启成功
 * @export
 * @returns
 */
export function waitRebootCpu1() {
  return event.execute({
    max: 1,
    interval: 300000,
    step: 'wait_reboot_cpu1',
    executeFn: noop,
    noSession: true,
    resolveCode: false
  });
}

export function setChannel(channel) {
  return RFBluetoothInstance.sendCommand(
    setParam.command('cfg.channel', channel),
    setParam
  );
}

export function saveChannel() {
  return RFBluetoothInstance.sendCommand(
    'save cfg.cfg cfg',
    {
      name: '保存设置',
      expect: ''
    }
  );
}

export function switchChannel(channel) {
  return runPromiseByQueue([setChannel.bind(null, channel), saveChannel]);
}

export function getDelayWorkCommand({
  start = '', // 冬眠开始时间
  end = '', // 冬眠结束时间
  hashHours = 24,
  hashSegs = 256
}) {
  return [
    `set bok.bk2hib[1].beg=${start}`,
    `set bok.bk2hib[1].end=${end} 00:00:00`,
    `set bok.bk2hib[1].hash_hours=${hashHours}`,
    `set bok.bk2hib[1].hash_segs=${hashSegs}`,
    'save bok.cfg bok'
  ];
}

// 检测速度对应的配置值
const speedRef = {
  '-2': {
    common: '0.10',
    in_snooze: '1111',
    in_nradar: '1',
    in_gradar: '555',
    out_snooze: '1111',
    out_nradar: '1',
    out_gradar: '555'
  },
  '-1': {
    common: '0.12',
    in_snooze: '5555',
    in_nradar: '1',
    in_gradar: '555',
    out_snooze: '5555',
    out_nradar: '1',
    out_gradar: '555'
  },
  0: {
    common: '0.12',
    in_snooze: '6666',
    in_nradar: '3',
    in_gradar: '2222',
    out_snooze: '5555',
    out_nradar: '3',
    out_gradar: '1111'
  },
  1: {
    common: '0.12',
    in_snooze: '8888',
    in_nradar: '3',
    in_gradar: '2222',
    out_snooze: '7777',
    out_nradar: '3',
    out_gradar: '1111',
  },
  2: {
    common: '0.18',
    in_snooze: '9999',
    in_nradar: '3',
    in_gradar: '4444',
    out_snooze: '9999',
    out_nradar: '3',
    out_gradar: '3333',
  }
};

/**
 * @description 获取地磁检测速度批命令
 * @export
 * @param {string} speed 检测速度
 * @returns
 */
export function getDetectSpeedCommand(inSpeed = '0', outSpeed = '0') {
  // 通用参数对检测速度无影响，所以现在可用的在用的快中慢速度通用参数统一使用0.15
  const inConf = speedRef[inSpeed];
  const outConf = speedRef[outSpeed];
  return [
    `set alg.up_gate[2]=${inConf.common}`,
    `set alg.dn_gate[2]=${inConf.common}`,
    `set cfg.snooze0=${inConf.in_snooze}`,
    `set alg.nradar0=${inConf.in_nradar}`,
    `set alg.gradar0=${inConf.in_gradar}`,
    `set cfg.snooze1=${outConf.out_snooze}`,
    `set alg.nradar1=${outConf.out_nradar}`,
    `set alg.gradar1=${outConf.out_gradar}`,
    'save cfg.cfg cfg',
    'save alg.cfg alg'
  ];
}

/**
 * @description 设置地磁检测速度
 * @export
 * @param {string} speed 检测速度
 * @returns
 */
export function setDetectSpeed(inSpeed, outSpeed, oCommand = []) {
  let cmds = getDetectSpeedCommand(inSpeed, outSpeed);

  cmds = cmds.concat(oCommand);

  return RFBluetoothInstance.sendBatchCommand(cmds.join('\r\n'));
}

export function submitSaveConf({
  start = '', // 冬眠开始时间
  end = '', // 冬眠结束时间
  hashHours = 24,
  hashSegs = 256,
  inSpeed = null,
  outSpeed = null,
  oCommand = [] // 其他需要添加到批命令里面的命令
}) {
  // eslint-disable-next-line no-param-reassign
  start = start || formatDateTime(new Date());
  const delayCmds = getDelayWorkCommand({
    start,
    end,
    hashHours,
    hashSegs
  });
  const detectCmds = (!inSpeed || !outSpeed) ? [] : getDetectSpeedCommand(inSpeed, outSpeed);
  const cmds = [].concat(delayCmds, detectCmds, [oCommand]);
  console.log('立即启用命令', cmds);
  return RFBluetoothInstance.sendBatchCommand(cmds.join('\r\n'));
}

/**
 * @description 设置地磁延期启用
 * @export
 * 命令列表：
 * set bok.bk2hib[1].beg=2020-01-01 00:00:00 // 设置预约冬眠的起始时间
 * set bok.bk2hib[1].end=2020-06-01 00:00:00 // 设置预约冬眠的结束时间
 * set bok.bk2hib[1].hash_hours=24           // 设置预约冬眠的离散时间段
 * set bok.bk2hib[1].hash_segs=256           // 设置预约冬眠的分为hash_segs片离散
 * save bok.cfg bok                      // 保存配置文件
 */
export function setDelayWork({
  start = '', // 冬眠开始时间
  end = '', // 冬眠结束时间
  hashHours = 24,
  hashSegs = 256,
  inSpeed = null,
  outSpeed = null,
  oCommand = ['goto WORK'] // 其他需要添加到批命令里面的命令
}) {
  // eslint-disable-next-line no-param-reassign
  start = start || formatDateTime(new Date());
  const delayCmds = getDelayWorkCommand({
    start,
    end,
    hashHours,
    hashSegs
  });
  const detectCmds = (!inSpeed || !outSpeed) ? [] : getDetectSpeedCommand(inSpeed, outSpeed);
  const cmds = [...delayCmds, ...detectCmds, ...oCommand];
  console.log('延期启用命令', cmds);
  return RFBluetoothInstance.sendBatchCommand(cmds.join('\r\n'));
}

/**
 * @description 设置NB地磁自动校时
 * @export
 * 命令列表：
 * set cfg.synctime_nb=1 // 置NB地磁自动校时
 * save cfg.cfg cfg      // 保存配置参数
 */
export function autoSyncTime() {
  return RFBluetoothInstance.sendBatchCommand('set cfg.synctime_nb=1\r\nsave cfg.cfg cfg');
}

/**
 * @description 设置NB夜间模式
 * @export
 * 命令列表：
 * set bok.bk2slp.beg=2020-08-01 23:00:00 // 夜间模式开始时间
 * set bok.bk2slp.end=2020-08-02 07:00:00 // 夜间模式结束时间
 * set cfg.slpdetect=1 // 开启夜间休眠检测
 * save bok.cfg bok      // 保存配置参数
 */

export function setNightModeCommond(startTime, endTime) {
  const command = [
    `set bok.bk2slp.beg=2020-08-01 ${startTime}`,
    `set bok.bk2slp.end=2020-08-01 ${endTime}`,
    'set cfg.slpdetect=1',
    'save cfg.cfg cfg',
    'save bok.cfg bok'
  ];
  return RFBluetoothInstance.sendBatchCommand(command.join('\r\n'));
}
